export default __webpack_public_path__ + "img/line-shape.ced8e63.svg";